module.exports = __webpack_public_path__ + "static/media/rookieUnlocked.26cc9701.png";